import moment from 'moment';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import css from './index.css'

const timeFormat = (time) => moment(time).format("DD/MM/YY")
const numberFormat = (number) => Number(number).toFixed(2);
class FuelCostHint extends Component {
  render() {
    const {
      list,
      updateTime,
      onHintClick
    } = this.props
    return (
      <div className={css.fuelCostHint} onClick={onHintClick}>
        EIA FUEL PRICE
        <div className={css.fuelCostHintIcon}>
          <div className={css.fuelCostHintBodyWarp}>
            <div className={css.fuelCostHintBody}>
              <div className={css.fuelCostHintHead}>
                <div className={css.fuelCostHintHeadTime}>
                  UPDATED ON {timeFormat(updateTime)}
                </div>
                <div className={css.fuelCostHintHeadDesc}>
                  *Ultra low sulfur, including taxes
                </div>
              </div>
              <div className={css.fuelCostHintBar}></div>
              <div className={css.fuelCostHintContent}>
                {
                  list.map((item, index)=> {
                    return (
                      <div>
                        <div className={css.fuelCostHintContentItem}>
                          <div className={css.fuelCostHintContentItemTitle}>{item.displayName}</div>
                          <div className={css.fuelCostHintContentItemPrice}>{numberFormat(item.price)}</div>
                        </div>
                        { item.child &&
                          item.child.map((item)=> {
                            return (
                              <div className={css.fuelCostHintContentItemSecond}>
                                <div className={css.fuelCostHintContentItemTitle}>{item.displayName}</div>
                                <div className={css.fuelCostHintContentItemPrice}>{numberFormat(item.price)}</div>
                              </div>
                            )
                          })
                        }
                        {
                          index !== list.length-1 && <div className={css.fuelCostHintBar}></div>
                        }
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default connect(({fuelSurcharge})=>{
  return {
    list: fuelSurcharge.list,
    updateTime: fuelSurcharge.updateAt
  }
},mapDispatch({
  
}))(FuelCostHint)


// WEBPACK FOOTER //
// ./src/components/common/FuelSurcharge/components/FuelCostHint/index.js